var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-upload",
        _vm._b(
          {
            attrs: {
              action: _vm.item.action,
              "before-upload": _vm.beforeUpload,
              "file-list": _vm.fileList,
              "on-preview": _vm.handlePictureCardPreview,
              "on-remove": _vm.handleRemove,
              "on-exceed": _vm.handleExceed,
              "on-success": _vm.uploadSuccess,
              "on-progress": _vm.handleProgress,
              "list-type": "picture-card",
            },
          },
          "el-upload",
          Object.assign({}, _vm.item),
          false
        ),
        [_c("i", { staticClass: "el-icon-plus" })]
      ),
      _vm.showViewer
        ? _c("el-image-viewer", {
            attrs: {
              "z-index": 9999,
              "on-close": _vm.handleCloseImageViewer,
              "initial-index": _vm.showImageIndex,
              "url-list": _vm.urlList,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }